export enum SilentErrorsEnum  {
  VIBRATE_ERROR = "Browser does not support the vibrate API",
  SHARE_CANCELED = "Share Canceled",
  AUTH_CANCELLED = "Authentication canceled.",
  INVALID_PASSWORD = "Invalid identifier or password"
}